import{apolloMutate as t}from"../graphql/index.js";import{InsertPurchaseDocument as r}from"../types/generated.js";var a=new class{constructor(){this.insertPurchase=a=>t({mutation:r,variables:a}).then((t=>t.data))}};export{a as default};
